module.exports = require("webpack-bundle-analyzer");


//////////////////
// WEBPACK FOOTER
// external "webpack-bundle-analyzer"
// module id = 50
// module chunks = 0